<template>
  <div>
    <riseup-header
      :color-variant="'yellow'"
      :logo-color="'green'"
    />
    <div class="success">
      <div class="padding-left-ml padding-top-l padding-right-ml">
        <div class="ri-glbl-medium-display">
          <div>Your 7 day free trial starts now.</div>
        </div>
        <div class="ri-glbl-large-body margin-top-s margin-bottom-l">
          <div>Want to find out your monthly forecast? Download the app now.</div>
        </div>
        <div class="margin-bottom-s">
          <img
            :src="appstore"
            class="store-logo"
            @click="openStoreLink(appStoreLink, 'AppStore')"
          >
          <img
            :src="play"
            class="store-logo"
            @click="openStoreLink(playStoreLink, 'PlayStore')"
          >
        </div>
      </div>
      <img :src="appPhoto">
      <button-footer
        button-text="Download the app"
        :color="'yellow'"
        :action="goToStore"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import Cookies from 'js-cookie';
import play from '../../assets/google-play.svg';
import appstore from '../../assets/app-store.svg';
import appPhoto from '../../assets/app-photo.svg';
import RiseupHeader from '../Common/RiseupHeader.vue';
import ButtonFooter from '../Common/ButtonFooter.vue';
import Segment from '../../Segment';
import { Device } from '../../types/session';
import { useSessionStore } from '../../stores/session';

const { memberId } = useSessionStore();

Segment.trackUserGot('SuccessScreenEntered', { gclid: Cookies.get('gclid'), memberId });
const appStoreLink = 'https://apps.apple.com/us/app/riseup-financial-wellbeing/id6449248281';
const playStoreLink = 'https://play.google.com/store/apps/details?id=com.riseup.android.uk';

const deviceStoreMap = {
  [Device.iOS]: appStoreLink,
  [Device.Android]: playStoreLink,
};

const goToStore = async () => {
  const device = detectDevice() || Device.Android;
  Segment.trackUserInteraction('SubscriptionSuccessScreenClicked', { device, memberId });
  window.location.href = deviceStoreMap[device];
};

function detectDevice(): Device | undefined {
  const userAgent = navigator.userAgent || navigator.vendor;

  if (/iPad|iPhone|iPod/.test(userAgent)) {
    return Device.iOS;
  }

  if (/android/i.test(userAgent)) {
    return Device.Android;
  }

  return undefined;
}

function openStoreLink(link: string, store: 'AppStore' | 'PlayStore') {
  Segment.trackUserInteraction('SubscriptionSuccessScreenStoreClicked', { store, memberId });
  window.open(link, '_blank');
}
</script>

<style scoped lang="scss">
@import '@riseupil/base-ui/src/scss/riseup-colors';
.success {
  background-color: $riseup-light-yellow;
    margin-bottom: 12px;

  .store-logo {
    height: 46px;
    margin-right: 12px;
  }
}
</style>
